"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@unite-us/ui");
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SHORT_LABEL_MAX_LENGTH = 40;
var columnClass = function columnClass(label, isLabelColumn) {
  var longLabel = (0, _lodash.get)(label, 'length', 0) > SHORT_LABEL_MAX_LENGTH;
  if (!longLabel) {
    return (0, _classnames["default"])({
      'radio-column': isLabelColumn,
      'col-sm-4': isLabelColumn,
      'col-sm-8': !isLabelColumn
    });
  }
  return (0, _classnames["default"])({
    'radio-column': isLabelColumn,
    'col-sm-6': true
  });
};
var ConsentTypeChoice = /*#__PURE__*/function (_Component) {
  _inherits(ConsentTypeChoice, _Component);
  var _super = _createSuper(ConsentTypeChoice);
  function ConsentTypeChoice(props) {
    var _this;
    _classCallCheck(this, ConsentTypeChoice);
    _this = _super.call(this, props);
    _this.onSelect = _this.onSelect.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ConsentTypeChoice, [{
    key: "onSelect",
    value: function onSelect() {
      this.props.onSelect(this.props.type);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        dropzone = _this$props.dropzone,
        label = _this$props.label,
        selectedType = _this$props.selectedType,
        type = _this$props.type;
      var isSelected = type === selectedType;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "consent-type-choice"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: columnClass(label, true)
      }, /*#__PURE__*/_react["default"].createElement(_ui.RadioField, {
        id: type,
        name: type,
        value: isSelected ? type : '',
        onChange: this.onSelect,
        options: [{
          label: label,
          value: type
        }]
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: columnClass(label, false)
      }, isSelected ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "consent-type-choice__children"
      }, children) : null)), isSelected && dropzone ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "row consent-type-choice__dropzone"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-12"
      }, dropzone)) : null);
    }
  }]);
  return ConsentTypeChoice;
}(_react.Component);
ConsentTypeChoice.propTypes = {
  /** Children content shown on the right side of the radio field */
  children: _propTypes["default"].node.isRequired,
  /** Represents the dropzone file transfer if addeded */
  dropzone: _propTypes["default"].any,
  /** Label of the RadioField */
  label: _propTypes["default"].node.isRequired,
  /** Function when radio is selected */
  onSelect: _propTypes["default"].func.isRequired,
  /** Value of what is currently selected via parent component */
  selectedType: _propTypes["default"].string.isRequired,
  /** Value of ConsentTypeChoice component */
  type: _propTypes["default"].string.isRequired
};
ConsentTypeChoice.defaultProps = {
  dropzone: null
};
var _default = exports["default"] = ConsentTypeChoice;